import type { FieldVisitPlace } from './types/FieldOperations';

const toNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

const toText = (value: unknown): string | undefined => {
  const text = value === null || value === undefined ? '' : String(value).trim();
  return text ? text : undefined;
};

export const normalizeVisitPlace = (value: any): FieldVisitPlace | undefined => {
  if (!value) {
    return undefined;
  }

  const place: FieldVisitPlace = {
    locationId: toText(value.locationId),
    address: toText(value.address),
    latitude: toNumber(value.latitude),
    longitude: toNumber(value.longitude),
    radiusMeters: toNumber(value.radiusMeters),
  };

  return hasVisitPlace(place) ? place : undefined;
};

export const hasVisitPlace = (place?: FieldVisitPlace | null): boolean => Boolean(
  place && (place.locationId || place.address || place.latitude != null || place.longitude != null),
);

/** The API treats an all-empty payload as "clear the visit place". */
export const emptyVisitPlace: FieldVisitPlace = {};
